module.exports = __webpack_public_path__ + "static/img/sy-img5.489cf2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sy-img5.png
// module id = Ctey
// module chunks = 1